export const OUTFIELD_FORMATION_LABELS = {
  nolla_pertsa: 'Pertsa nolla',
  vasuri: 'Vasuri',
  kaannetty: 'Käännetty',
  kolmospuolen_kaanto: '3-puolen kääntö',
  normaali: 'Normaali vaihtotilanne',
  syvapussi: 'Syvä pussi',
  sailytys_vaihto: 'Säilytys vaihto',
  kasari: 'Kasari',
  nolla_vaihdossa: 'Nollan kuvio vaihtotilanteessa',
  oulu: 'Oulu',
  pertsa: 'Pertsa',
  kaannetty_oulu: 'Käännetty oulu',
  kaannetty_pertsa: 'Käännetty pertsa',
  tahko: 'Tahko',
  vasurin_tahko: 'Vasurin tahko',
  sailytys_takanen: 'Säilytys takanen',
  karvaus_yksi: 'Karvaus yhdellä',
  karvaus_kaksi: 'Karvaus kahdella',
  karvaus_ykkostilanne: 'Ykköstilannekarvaus',
  '1v_irti': '1-v irti'
}

const PALETTE = [
  '#2563eb',
  '#7c3aed',
  '#ec4899',
  '#f97316',
  '#f59e0b',
  '#10b981',
  '#0ea5e9',
  '#ef4444',
  '#14b8a6',
  '#a855f7',
  '#22c55e',
  '#6366f1',
  '#eab308',
  '#06b6d4',
  '#84cc16',
  '#d946ef',
  '#f43f5e',
  '#0d9488',
  '#3b82f6',
  '#a3e635'
]

const FORMATION_COLOR_INDEX = Object.keys(OUTFIELD_FORMATION_LABELS).reduce((acc, key, idx) => {
  acc[key] = idx
  return acc
}, {})

const hashFormationKey = value => {
  let hash = 0
  const str = String(value)
  for(let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0
  }
  return hash
}

export const formationLabel = value => OUTFIELD_FORMATION_LABELS[value] || value

export const formationColor = value => {
  const known = FORMATION_COLOR_INDEX[value]
  if(known !== undefined) return PALETTE[known % PALETTE.length]
  return PALETTE[hashFormationKey(value) % PALETTE.length]
}
